// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
import { Controller } from "@hotwired/stimulus"

import EditorJS from '@editorjs/editorjs';
import HeaderTool from '@editorjs/header';
import List from '@editorjs/list';
import Paragraph from '@editorjs/paragraph';
// import Checklist from '@editorjs/checklist';
import Quote from '@editorjs/quote';
// import Warning from '@editorjs/warning';
import Delimiter from '@editorjs/delimiter';
import InlineCode from '@editorjs/inline-code';
// import LinkTool from '@editorjs/link';
import Embed from '@editorjs/embed';
import Table from '@editorjs/table';
import ImageTool from '@editorjs/image';
import Marker from '@editorjs/marker';



import LinkInlineTool from "../extends/editor-link.js"

import { getUploadParameters } from "../helpers/editor.js"

async function upload(file) {
  return getUploadParameters(file).then((res) => {
    if (res && res.error) {
      const error = new Error(res.message)
      Object.assign(error, res.error)
      throw error
    }

    const {
      url,
      fields,
      headers,
    } = res.data

    let uploadParams = {}

    if (headers) {
      uploadParams['headers'] = headers
    }

    const formData = new FormData()
    
    Object.entries(fields).forEach(([k, v]) =>{
      formData.append(k, v)
    })

    formData.append('file', file, file.name)

    let fileurl
    var reader = new FileReader();
    reader.onload = function(event){
      fileurl = event.target.result
    }
    reader.readAsDataURL(file)
    
    const axios = require('axios')

    return axios.post(
      url,
      formData,
      uploadParams).then((res) => {
        if (res) {
          return {
            success: 1,
            file: {
              url: (window.URL || window.webkitURL).createObjectURL(file),
              cache_url: res.headers.location,
              key: fields.key,
              size: file.size,
              mime_type: file.type,
              filename: file.name,
              date: Date.now(),
              random: (Math.random() + 1).toString(36).substring(3)
            }
          }
        } else {
          return {
            success: 0
          }
        }
    })

  })
}


Embed.prototype.render = function(suffix) {
  if (!this.data.service) {
    const container = document.createElement('div');

    this.element = container;

    return container;
  }

  const { html } = Embed.services[this.data.service];
  const container = document.createElement('div');
  const caption = document.createElement('div');
  const template = document.createElement('template');
  const preloader = this.createPreloader();

  container.classList.add(this.CSS.baseClass, this.CSS.container, this.CSS.containerLoading);
  caption.classList.add(this.CSS.input, this.CSS.caption);

  container.appendChild(preloader);

  caption.contentEditable = !this.readOnly;
  caption.dataset.placeholder = this.api.i18n.t('Enter a caption');
  caption.innerHTML = this.data.caption || '';

  template.innerHTML = html;
  template.content.firstChild.setAttribute('src', this.data.embed);
  template.content.firstChild.classList.add(this.CSS.content);

  const embedIsReady = this.embedIsReady(container);

  template.content.firstChild.innerHTML = template.content.firstChild.innerHTML.replace(/---url---/gi, this.data.embed);

  container.appendChild(template.content.firstChild);
  container.appendChild(caption);

  embedIsReady
    .then(() => {
      container.classList.remove(this.CSS.containerLoading);
    });

  this.element = container;

  return container;
};

export default class extends Controller {

  static targets = [ "editor" ]

  initialize() {}

  connect() {
    if (this.editorTargets.length > 0) {
      this.editorTargets.forEach((el) => {
          this.mount($(el))
        document.addEventListener('turbolinks:before-cache', () => {
          this.unmount($(el))
        }, {once: true})
      })
    }

    const el = $( this.element )

  }
  
  mount(theArea) {
    const blocksInput = document.getElementById(theArea.prop('id').replace('_holder',''))
    const assetsHost = theArea.data('assets-host')
    let blocks = blocksInput.value
    if (blocks) {
      blocks = JSON.parse(blocks)
      blocks.forEach((el) => {
        if (el.type == 'image' && !el.data.file.url.includes(`https://${assetsHost}`)) {
          el['data']['file']['url'] = `https://${assetsHost}${el.data.file.url}`
        }
      })
    }

    const editor = new EditorJS({
      holder: theArea.attr('id'),
      placeholder: 'Enter text here...',
      /**
      * Available Tools list.
      * Pass Tool's class or Settings object for each Tool you want to use
      */
      minHeight : 100,
      data: {
        blocks: blocks
      },
      onChange: (api, event) => {
        editor.save().then((outputData) => {
          blocksInput.value = JSON.stringify(outputData.blocks)
          // console.log(blocksInput.value)
        }).catch((error) => {
          console.log('Saving failed: ', error)
        });
      },
      tools: {
        link: {
          class: LinkInlineTool,
          inlineToolbar: true,
        },
        paragraph: {
          class: Paragraph,
          inlineToolbar: true,
        },
        header: {
          class: HeaderTool,
          inlineToolbar: true,
          config: {
            placeholder: 'Header'
          },
          shortcut: 'CMD+SHIFT+H'
        },
        marker: {
          class: Marker,
          shortcut: 'CMD+SHIFT+M',
        },
        image: {
          class: ImageTool,
            config: {
              uploader: {
                /**
                 * Upload file to the server and return an uploaded image data
                 * @param {File} file - file selected from the device or pasted by drag-n-drop
                 * @return {Promise.<{success, file: {url}}>}
                 */
                async uploadByFile(file) {
                  return upload(file)
                },
                async uploadByUrl(url) {
                  return await fetch(url)
                    .then(res => res.blob())
                    .then(blob => {
                      let filename = (Math.random() + 1).toString(36).substring(3)
                      let extention = blob.type.split('/').at(-1)
                      let file = new File([blob], `${filename}.${extention}`, { type: blob.type, lastModified: new Date().getTime() })
                      return upload(file)
                  })
                },
                
              }
            }
        },        
        list: {
          class: List,
          inlineToolbar: true,
          shortcut: 'CMD+SHIFT+L'
        },
        // checklist: {
        //   class: Checklist,
        //   inlineToolbar: true,
        // },
        quote: {
          class: Quote,
          inlineToolbar: true,
          config: {
            quotePlaceholder: 'Enter a quote',
            captionPlaceholder: 'Quote\'s author',
          },
          shortcut: 'CMD+SHIFT+O'
        },
        // warning: Warning,
        delimiter: Delimiter,
        inlineCode: {
          class: InlineCode,
          shortcut: 'CMD+SHIFT+C'
        },
        // linkTool: LinkTool,
        embed: {
          class: Embed,
          config: {
            captionPlaceholder: 'Enter a caption',
            services: {
              vimeo: {
                regex: /(?:http[s]?:\/\/)?(?:www.)?(?:player.)?vimeo\.co(?:.+\/([^\/]\d+)(?:#t=[\d]+)?s?$)/,
                embedUrl: 'https://player.vimeo.com/video/<%= remote_id %>?title=0&byline=0',
                html: '<iframe style="width:100%;" height="320" frameborder="0"></iframe>',
                height: 320,
                width: 580,
              },
              youtube: {
                regex: /(?:https?:\/\/)?(?:www\.)?(?:(?:youtu\.be\/)|(?:youtube\.com)\/(?:v\/|u\/\w\/|embed\/|watch))(?:(?:\?v=)?([^#&?=]*))?((?:[?&]\w*=\w*)*)/,
                embedUrl: 'https://www.youtube.com/embed/<%= remote_id %>',
                html: '<iframe style="width:100%;" height="320" frameborder="0" allowfullscreen></iframe>',
                height: 320,
                width: 580,
                id: ([id, params]) => {
                  if (!params && id) {
                    return id;
                  }
            
                  const paramsMap = {
                    start: 'start',
                    end: 'end',
                    t: 'start',
                    // eslint-disable-next-line camelcase
                    time_continue: 'start',
                    list: 'list',
                  };
            
                  params = params.slice(1)
                    .split('&')
                    .map(param => {
                      const [name, value] = param.split('=');
            
                      if (!id && name === 'v') {
                        id = value;
            
                        return null;
                      }
            
                      if (!paramsMap[name]) {
                        return null;
                      }
            
                      if (value === 'LL' 
                        || value.startsWith('RDMM')
                        || value.startsWith('FL')) {
                        return null;
                      }
            
                      return `${paramsMap[name]}=${value}`;
                    })
                    .filter(param => !!param);
            
                  return id + '?' + params.join('&');
                },
              },
              coub: {
                regex: /https?:\/\/coub\.com\/view\/([^\/\?\&]+)/,
                embedUrl: 'https://coub.com/embed/<%= remote_id %>',
                html: '<iframe style="width:100%;" height="320" frameborder="0" allowfullscreen></iframe>',
                height: 320,
                width: 580,
              },
              vine: {
                regex: /https?:\/\/vine\.co\/v\/([^\/\?\&]+)/,
                embedUrl: 'https://vine.co/v/<%= remote_id %>/embed/simple/',
                html: '<iframe style="width:100%;" height="320" frameborder="0" allowfullscreen></iframe>',
                height: 320,
                width: 580,
              },
              imgur: {
                regex: /https?:\/\/(?:i\.)?imgur\.com.*\/([a-zA-Z0-9]+)(?:\.gifv)?/,
                embedUrl: 'http://imgur.com/<%= remote_id %>/embed',
                html: '<iframe allowfullscreen="true" scrolling="no" id="imgur-embed-iframe-pub-<%= remote_id %>" class="imgur-embed-iframe-pub" style="height: 500px; width: 100%; border: 1px solid #000"></iframe>',
                height: 500,
                width: 540,
              },
              gfycat: {
                regex: /https?:\/\/gfycat\.com(?:\/detail)?\/([a-zA-Z]+)/,
                embedUrl: 'https://gfycat.com/ifr/<%= remote_id %>',
                html: "<iframe frameborder='0' scrolling='no' style=\"width:100%;\" height='436' allowfullscreen ></iframe>",
                height: 436,
                width: 580,
              },
              'twitch-channel': {
                regex: /https?:\/\/www\.twitch\.tv\/([^\/\?\&]*)\/?$/,
                embedUrl: 'https://player.twitch.tv/?channel=<%= remote_id %>',
                html: '<iframe frameborder="0" allowfullscreen="true" scrolling="no" height="366" style="width:100%;"></iframe>',
                height: 366,
                width: 600,
              },
              'twitch-video': {
                regex: /https?:\/\/www\.twitch\.tv\/(?:[^\/\?\&]*\/v|videos)\/([0-9]*)/,
                embedUrl: 'https://player.twitch.tv/?video=v<%= remote_id %>',
                html: '<iframe frameborder="0" allowfullscreen="true" scrolling="no" height="366" style="width:100%;"></iframe>',
                height: 366,
                width: 600,
              },
              'twitch-clip': {
                regex: /https?:\/\/www\.twitch\.tv\/[^\/\?\&]*\/clip\/([^\/\?\&]*).*/,
                embedUrl: 'https://clips.twitch.tv/embed?clip=<%= remote_id %>&autoplay=false&parent={{server_hostname}}',
                html: '<iframe frameborder="0" allowfullscreen="true" scrolling="no" height="366" style="width:100%;"></iframe>',
                height: 300,
                width: 600
              },
              'twitch-clip-2': {
                regex: /https?:\/\/clips\.twitch\.tv\/([^\/\?\&]*).*/,
                embedUrl: 'https://clips.twitch.tv/embed?clip=<%= remote_id %>&autoplay=false&parent={{server_hostname}}',
                html: '<iframe frameborder="0" allowfullscreen="true" scrolling="no" height="366" style="width:100%;"></iframe>',
                height: 300,
                width: 600
              },
              'yandex-music-album': {
                regex: /https?:\/\/music\.yandex\.ru\/album\/([0-9]*)\/?$/,
                embedUrl: 'https://music\.yandex\.ru/iframe/#album/<%= remote_id %>/',
                html: '<iframe frameborder=\"0\" style=\"border:none;width:540px;height:400px;\" style=\"width:100%;\" height=\"400\"></iframe>',
                height: 400,
                width: 540,
              },
              'yandex-music-track': {
                regex: /https?:\/\/music\.yandex\.ru\/album\/([0-9]*)\/track\/([0-9]*)/,
                embedUrl: 'https://music\.yandex\.ru/iframe/#track/<%= remote_id %>/',
                html: '<iframe frameborder="0" style="border:none;width:540px;height:100px;" style="width:100%;" height="100"></iframe>',
                height: 100,
                width: 540,
                id: (ids) => ids.join('/'),
              },
              'yandex-music-playlist': {
                regex: /https?:\/\/music\.yandex\.ru\/users\/([^\/\?\&]*)\/playlists\/([0-9]*)/,
                embedUrl: 'https://music\.yandex\.ru/iframe/#playlist/<%= remote_id %>/show/cover/description/',
                html: '<iframe frameborder="0" style="border:none;width:540px;height:400px;" width="540" height="400"></iframe>',
                height: 400,
                width: 540,
                id: (ids) => ids.join('/'),
              },
              codepen: {
                regex: /https?:\/\/codepen\.io\/([^\/\?\&]*)\/pen\/([^\/\?\&]*)/,
                embedUrl: 'https://codepen.io/<%= remote_id %>?height=300&theme-id=0&default-tab=css,result&embed-version=2',
                html: "<iframe height='300' scrolling='no' frameborder='no' allowtransparency='true' allowfullscreen='true' style='width: 100%;'></iframe>",
                height: 300,
                width: 600,
                id: (ids) => ids.join('/embed/'),
              },
              instagram: {
                regex: /https?:\/\/www\.instagram\.com\/p\/([^\/\?\&]+)\/?.*/,
                embedUrl: 'https://www.instagram.com/p/<%= remote_id %>/embed',
                html: '<iframe width="400" height="505" style="margin: 0 auto;" frameborder="0" scrolling="no" allowtransparency="true"></iframe>',
                height: 505,
                width: 400,
              },
              twitter: {
                regex: /^https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+?.*)?$/,
                embedUrl: 'https://twitframe.com/show?url=https://twitter.com/<%= remote_id %>',
                html: '<iframe width="600" height="600" style="margin: 0 auto;" frameborder="0" scrolling="no" allowtransparency="true"></iframe>',
                height: 300,
                width: 600,
                id: ids => ids.join('/status/'),
              },
              pinterest: {
                regex: /https?:\/\/([^\/\?\&]*).pinterest.com\/pin\/([^\/\?\&]*)\/?$/,
                embedUrl: 'https://assets.pinterest.com/ext/embed.html?id=<%= remote_id %>',
                html: "<iframe scrolling='no' frameborder='no' allowtransparency='true' allowfullscreen='true' style='width: 100%; min-height: 400px; max-height: 1000px;'></iframe>",
                id: (ids) => {
                  return ids[1];
                },
              },
              facebook: {
                regex: /https?:\/\/www.facebook.com\/([^\/\?\&]*)\/(.*)/,
                embedUrl: 'https://www.facebook.com/plugins/post.php?href=https://www.facebook.com/<%= remote_id %>&width=500',
                html: "<iframe scrolling='no' frameborder='no' allowtransparency='true' allowfullscreen='true' style='width: 100%; min-height: 500px; max-height: 1000px;'></iframe>",
                id: (ids) => {
                  return ids.join('/');
                },
              },
              aparat: {
                regex: /(?:http[s]?:\/\/)?(?:www.)?aparat\.com\/v\/([^\/\?\&]+)\/?/,
                embedUrl: 'https://www.aparat.com/video/video/embed/videohash/<%= remote_id %>/vt/frame',
                html: '<iframe width="600" height="300" style="margin: 0 auto;" frameborder="0" scrolling="no" allowtransparency="true"></iframe>',
                height: 300,
                width: 600,
              },
              miro: {
                regex: /https:\/\/miro.com\/\S+(\S{12})\/(\S+)?/,
                embedUrl: 'https://miro.com/app/live-embed/<%= remote_id %>',
                html: '<iframe width="700" height="500" style="margin: 0 auto;" allowFullScreen frameBorder="0" scrolling="no"></iframe>',
              },
              twitter: {
                regex: /https?:\/\/twitter.com\/([^\/\?\&]*)\/status\/([^\/\?\&]*)/,
                embedUrl: 'https://twitter.com/<%= remote_id %>',
                html: '<blockquote class="twitter-tweet"><p dir="ltr"><a href="---url---"></a></p></blockquote>',
                height: 300,
                width: 600,
                id: (groups) => groups.join('/status/')
              },
              instagram: {
                regex: /https?:\/\/www.instagram.com\/p\/([^\/\?\&]*)\/*/,
                embedUrl: 'https://www.instagram.com/p/<%= remote_id %>/',
                html: '<blockquote class="instagram-media" data-instgrm-permalink="---url---"></blockquote>',
                height: 300,
                width: 600
              },
              tiktok: {
                regex: /https:\/\/www.tiktok.com\/([^\/\?\&]*)\/video\/(\d+)\??.*/,
                embedUrl: 'https://www.tiktok.com/<%= remote_id %>',
                html: '<blockquote class="tiktok-embed" cite="---url---"><section></section></blockquote>',
                height: 300,
                width: 600,
                id: (groups) => groups.join('/video/')
              },
              reddit: {
                regex: /https:\/\/www.reddit.com\/(.+)\/\??.*/,
                embedUrl: 'https://www.reddit.com/<%= remote_id %>/',
                html: '<blockquote class="reddit-card"><a href="---url---">...</a></blockquote>',
                height: 300,
                width: 600
              },
              vk: {
                regex: /https?:\/\/vk\.com\/video(-?\d+)_(\d+)/,
                embedUrl: '<%= remote_id %>',
                html: '<iframe frameborder="0" allowfullscreen></iframe>',
                height: 300,
                width: 600,
                id: ([gid, id]) => {
                  if (!gid || !id) {
                    return '';
                  }
                  return vk_video(gid, id);
                }
              },
              vgtrk: {
                regex: /https?:\/\/player\.vgtrk\.com\/iframe\/video\/id\/(\d+).*/,
                embedUrl: 'https://player.vgtrk.com/iframe/video/id/<%= remote_id %>/start_zoom/true/showZoomBtn/false/sid/vesti/isPlay/true/',
                html: '<iframe frameborder="0" allowfullscreen="true" scrolling="no" height="366" style="width:100%;"></iframe>',
                height: 300,
                width: 600
              },
              stage: {
                regex: /@stage-(\d+)/,
                embedUrl: '<%= remote_id %>',
                html: '<blockquote>@stage----url---</blockquote>'
              },
              match: {
                regex: /@match-(\d+)/,
                embedUrl: '<%= remote_id %>',
                html: '<blockquote>@match----url---</blockquote>'
              },
              news: {
                regex: /https:\/\/.{5,30}\.com\/.{2,30}\/news\/(\d+)-.+/,
                embedUrl: '<%= remote_id %>',
                html: '<blockquote>@news----url---</blockquote>'
              },
              article: {
                regex: /https:\/\/.{5,30}\.com\/.{2,30}\/article\/(\d+)-.+/,
                embedUrl: '<%= remote_id %>',
                html: '<blockquote>@article----url---</blockquote>'
              },
              blog: {
                regex: /https:\/\/.{5,30}\.com\/.{2,30}\/blog\/(\d+)-.+/,
                embedUrl: '<%= remote_id %>',
                html: '<blockquote>@blog----url---</blockquote>'
              }
            }
          }
        },
        table: {
          class: Table,
          inlineToolbar: true,
          shortcut: 'CMD+ALT+T'
        }
      },
    });
  }

  unmount(el) {
    
  }
}
